import React from 'react';
import axios from 'axios';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import {Button, Modal, OverlayTrigger, Tooltip} from "react-bootstrap";
import { Link, withRouter } from "react-router-dom";

import Table from "../../components/Table/index";
import Answers from "./Answers";
import { connect } from 'react-redux';
import { getQuestions } from '../../redux/actions/questionActions';

class QuestionList extends React.Component{
    constructor(props) {
        super(props);
        moment.locale('cs');

        const tooltipPreview = (
            <Tooltip id="tooltip-preview">Náhled</Tooltip>
        );
        const tooltipImage = (
            <Tooltip id="tooltip-image">Přidat/upravit obrázek</Tooltip>
        );
        const tooltipEnable = (
            <Tooltip id="tooltip-enable">Zakázat otázku</Tooltip>
        );
        const tooltipDisable = (
            <Tooltip id="tooltip-disable">Povolit otázku</Tooltip>
        );
        const tooltipEdit = (
            <Tooltip id="tooltip-edit">Upravit</Tooltip>
        );
        const tooltipRemove = (
            <Tooltip id="tooltip-remove">Odstranit</Tooltip>
        );

        const columns = [{
            Header: 'Číslo otázky',
            accessor: 'name',
        },{
            Header: 'Znění',
            accessor: 'text',
        },{
            Header: 'Časová náročnost',
            accessor: 'timeframe',
        },{
            Header: 'Tagy',
            accessor: 'tags'
        },{
            Header: 'Typ',
            accessor: 'questionTypeText'
        },{
            Header: 'Možnosti',
            style: {padding: '0px'},
            filterable: false,
            Cell: row => (
                <div className="row-menu">
                    <OverlayTrigger placement="top" overlay={tooltipPreview}>
                        <Link to={`/questions/preview/${row.original.id}`}>
                            <FontAwesome
                              name="eye"
                              className="cursor-p"
                            />
                        </Link>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={tooltipEdit}>
                        <Link to={`/questions/edit/${row.original.id}`}>
                            <FontAwesome
                              name="pencil-square-o"
                              className="cursor-p"
                            />
                        </Link>
                    </OverlayTrigger>
                    <OverlayTrigger placement="top" overlay={tooltipImage}>
                        <Link to={`/questions/image/${row.original.id}`}>
                            <FontAwesome name="picture-o" className="cursor-p" />
                        </Link>
                    </OverlayTrigger>
                    {
                        row.original.enabled &&
                        <OverlayTrigger placement="top" overlay={tooltipEnable}>
                            <FontAwesome name="unlock" onClick={() => this.props.handleChangeEnabled(row.original)}
                                         className="cursor-p"/>
                        </OverlayTrigger>
                    }
                    {
                        !row.original.enabled &&
                        <OverlayTrigger placement="top" overlay={tooltipDisable}>
                            <FontAwesome name="lock" onClick={() => this.props.handleChangeEnabled(row.original)}
                                         className="cursor-p"/>
                        </OverlayTrigger>
                    }
                    <OverlayTrigger placement="top" overlay={tooltipRemove}>
                        <FontAwesome name="trash" onClick={() => this.showModal(row.original)}
                                     className="cursor-p"/>
                    </OverlayTrigger>
                </div>
            )
        }];

        const tableOptions = {
            showPagination: true,
            showPageSizeOptions: true,
            showPageJump: true,
            collapseOnSortingChange: true,
            collapseOnPageChange: true,
            collapseOnDataChange: true,
            freezeWhenExpanded: false,
            filterable: true,
            sortable: true,
            resizable: true,
            defaultPageSize: 10,
            defaultSorted:[{
                id: 'name',
                desc: false
            }]
        };

        this.state = {
            questions: [],
            removeQuestion: null,
            columns: columns,
            tableOptions: tableOptions,
            expanded: {
                2: true
            }
        };

        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        const { sessionData, questions, loading, fceGetQuestions } = this.props;
        if (sessionData && !loading && !questions) {
            fceGetQuestions(sessionData.accessToken);
        }
    };

    componentWillReceiveProps(nextProps, nextContext) {
        const { sessionData, loading, questions, fceGetQuestions } = nextProps;
        if (sessionData && !loading && !questions) {
            fceGetQuestions(sessionData.accessToken);
        }
    }

    closeModal() {
        this.setState({
            showModal: false,
            removeQuestion: null
        })
    }

    showModal(question) {
        this.setState({
            showModal: true,
            removeQuestion: question
        })
    }

    render() {
        const { questions, loading } = this.props;
        const {columns, tableOptions} = this.state;

        const tblOpt = {
            ...tableOptions,
            loading,
        };

        const qs = questions ? Object.values(questions) : [];

        let SubComponent = (row) => {
            return (
                <div style={{padding: '5px 20px'}}>
                    <h6>Otázka - {row.original.text}</h6>
                    <Answers {...this.props} id={row.original.id} />
                </div>
            )
        };

        let { removeQuestion } = this.state;

        return (
            <div className="x-panel">
                <div className="x-title">
                    <h2>Seznam otázek</h2>
                    <Button className="btn-success btn-add" onClick={() => this.props.history.push('/questions/add')}>
                        <FontAwesome name="plus"/>
                    </Button>
                    <div className="clearfix"/>
                </div>
                <div className="x-content">
                    <Table
                        columns={columns}
                        data={qs || []}
                        tableOptions={tblOpt}
                        defaultFilterMethod={(filter, row) => (String(row[filter.id]).includes(filter.value))}
                        options={{SubComponent}}
                    />
                </div>
                {
                    removeQuestion &&
                    <Modal show={this.state.showModal} onHide={this.closeModal} backdrop='static'>
                        <Modal.Header closeButton className="text-danger bg-danger">
                            <Modal.Title>Odstranění otázky</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <p>Opravdu chcete odstranit otázku č. {removeQuestion.name}?</p>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={this.closeModal}>Zrušit</Button>
                            <Button className='btn btn-danger' onClick={() => this.props.handleRemoveQuestion(removeQuestion)}>Odstranit</Button>
                        </Modal.Footer>
                    </Modal>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    loading: state.questions.loading,
    questions: Object.values(state.questions.items).length ? state.questions.items : null,
});

const mapDispatchToProps = (dispatch) => ({
    fceGetQuestions: (token) => dispatch(getQuestions(token)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuestionList));



/** WEBPACK FOOTER **
 ** ./src/containers/Questions/QuestionList.js
 **/